import DataBlank from "../DataBlank";
import Data from "../types/Data";

export default function reset(_: Data, data = DataBlank): Data {
  return data;
}
